import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import apiRoutes from '../../../app/api/routes';

export default ComposedComponent => {
  class Countries extends Component {
    componentWillMount() {
      this.props.dispatchCountriesGet();
    }
    render() {
      return (
        <ComposedComponent
          {...this.props}
          getCountriesForSelectOptions={this.getCountriesForSelectOptions}
        />
      );
    }
  }

  Countries.propTypes = {
    countriesFetch: PropTypes.object.isRequired,
    dispatchCountriesGet: PropTypes.func.isRequired,
  };

  return compose(
    withTranslation(),
    reduxFetch(({ i18n }) => [
      {
        resource: 'countries',
        method: 'get',
        request: () => ({
          url: apiRoutes.countries(),
          comparison: new Date().toDateString() + i18n.language, // Only fetch once a day
        }),
      },
    ])
  )(Countries);
};
